<template>
  <div class="controlBox">
    <div class="leftjiantou" @click="leftclick">
      <svg-icon icon-class="jiantou_zuo" />
    </div>
    <div v-for="(item,index) in arryLength" :key="index" class="boxshow">
      <div :class="currentIndex==index?'activeli':'noactiveli'" @click="clickChange(index)" />
    </div>
    <div class="rightjiantou" @click="rightclick">
      <svg-icon icon-class="jiantou_you" />
    </div>
  </div>
</template>
<script>
export default {
  props: ['arryLength'],
  data() {
    return {
      currentIndex: 0,
      timer: null
    }
  },
  created() {

  },
  mounted() {
    this.autoChange()
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    autoChange() {
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.timer = setInterval(() => {
        if (this.currentIndex >= 0 && this.currentIndex < this.arryLength.length - 1) {
          this.currentIndex++
        } else {
          this.currentIndex = 0
        }
        this.$emit('indexchange', this.currentIndex)
      }, 3000)
    },
    clickChange(index) {
      this.currentIndex = index
      this.autoChange()
    },
    leftclick() {
      if (this.currentIndex > 0) {
        this.currentIndex--
      } else {
        this.currentIndex = this.arryLength.length - 1
      }
      this.autoChange()
    },
    rightclick() {
      if (this.currentIndex < this.arryLength.length - 1) {
        this.currentIndex++
      } else {
        this.currentIndex = 0
      }
      this.autoChange()
    }
  }

}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .controlBox{
        height: 20px;
        padding: 0 50px;
        position: relative;
        .leftjiantou{
            cursor: pointer;
            height: 20px;
            position: absolute;
            left: 0;
            top: 0;
            font-size: 20px;
            line-height: 20px;
            svg{
                font-size: 20px;
                color: #CCCCCC;
            }
        }
        .rightjiantou{
            cursor: pointer;
            height: 20px;
            position: absolute;
            right: 0;
            top: 0;
            font-size: 20px;
            line-height: 20px;
            svg{
                font-size: 20px;
                color: #CCCCCC;
            }
        }
        .boxshow{
            text-align: center;
            height: 20px;
            line-height: 20px;
            display: inline-block;
            width: 14px;
            vertical-align: top;
            margin: 0 3px;
            .activeli{
                display: inline-block;
                width: 14px;
                height: 5px;
                background-color: #7E6B5A;
                cursor: pointer;
            }
            .noactiveli{
                display: inline-block;
                width: 14px;
                height: 5px;
                background-color: #CCCCCC;
                cursor: pointer;
            }
        }
    }
</style>
